import axios from "@/libs/api.request";
// 获取列表
export const getAgentFee = params => {
  return axios.request({
    url: "/finance/cod/commission/agent",
    method: "get",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/finance/cod/commission/agent/${id}`,
    method: "get"
  });
};

// export const getConfig = () => {
//   return axios.request({
//     url: "/finance/cod/handleFee/config",
//     method: "get"
//   });
// };

export const add = data => {
  return axios.request({
    url: "/finance/cod/commission/agent",
    method: "post",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/finance/cod/commission/agent/${id}`,
    method: "delete"
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/cod/commission/agent/${data.id}`,
    method: "put",
    data
  });
};

export const getRules = id => {
  return axios.request({
    url: `/finance/cod/commission/agent/getRules/${id}`,
    method: "get"
  });
};

export const getRulesDetails = id => {
  return axios.request({
    url: `/finance/cod/commission/agent/readRule/${id}`,
    method: "get"
  });
};

export const createRules = data => {
  return axios.request({
    url: `/finance/cod/commission/agent/createRule/${data.id}`,
    method: "post",
    data
  });
};

export const updateRules = data => {
  return axios.request({
    url: `/finance/cod/commission/agent/editRule/${data.id}`,
    method: "post",
    data
  });
};

export const delRules = id => {
  return axios.request({
    url: `/finance/cod/commission/agent/delRule/${id}`,
    method: "post"
  });
};
